export default "__VITE_ASSET__BRVA8rWe__"